var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano/Série",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "maxlength": "25"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarSeries.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Quantidade de Bimestres",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.form.lists.quantidadeBimestres
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarSeries.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.quantidadeBimestres,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "quantidadeBimestres", $$v);
      },
      expression: "form.filters.quantidadeBimestres"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Modalidade de Ensino",
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "items": _vm.form.lists.modalidades,
      "item-value": "id",
      "item-text": "nome"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarSeries.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.modalidade,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "modalidade", $$v);
      },
      expression: "form.filters.modalidade"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 4,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarSeries
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarSeries();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterSerie();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "show-expand": "",
      "no-data-text": _vm.table.noDataText
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function (_ref) {
        var headers = _ref.headers,
          item = _ref.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-5",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('p', {
          staticClass: "ml-4 my-0 text-wrap mx-70vw"
        }, [_vm._v(" " + _vm._s(item.descricao) + " ")])])];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarSerie(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterSerie(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarSerie(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarSerieDialog', {
    attrs: {
      "edit": _vm.dialogManterSerie.edit,
      "visible": _vm.dialogManterSerie.visible,
      "content": _vm.dialogManterSerie.content,
      "modalidades": _vm.form.lists.modalidades,
      "quantidadeBimestres": _vm.form.lists.quantidadeBimestres
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterSerie.close();
      },
      "onSave": function ($event) {
        return _vm.buscarSeries();
      }
    }
  }), _vm.dialogVisualizarSerie.visible ? _c('VisualizarSerieDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarSerie.visible,
      "content": _vm.dialogVisualizarSerie.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarSerie.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }